// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
function getByPredicateOrFirst(array, predicate) {
  return Belt_Option.orElse(Belt_Array.getBy(array, predicate), Belt_Array.get(array, 0));
}
export { getByPredicateOrFirst };
/* No side effect */